import { createFileRoute } from '@tanstack/react-router';
import UploadPage from '@/features/resume-builder/upload';

/** EU-762 RN-07..12 — "Envie seu PDF". */
export const Route = createFileRoute('/modulos/$moduleId_/curriculo/enviar')({
  component: UploadPage,
});
